import { amplitudeClient, datadogClient,  siteblimpClient } from './clients';
import { fyiPlatform } from './util';
import { appVersion, inImpersonateMode } from 'helpers/constants';
import { flags, getFlag } from 'services/developer';
import { Logger, initTrackingContext } from 'services';

interface eventProps {
  'FYI Platform'?: string;
  'FYI Version'?: string;
  [otherProps: string]: any;
}

export const trackEvent = (event: string, props: eventProps = {}) => {
  props['FYI Platform'] = fyiPlatform();
  props['FYI Version'] = appVersion;

  if (!inImpersonateMode) {
    amplitudeClient.logEvent(event, props);
    siteblimpClient.track(event, props);
    datadogClient.addUserAction(event, props);
    if (getFlag(flags.AnalyticsEventLogger)) {
      Logger.info(event, props);
    }
  }
};

export const setIdentity = (identity: string, organization: string = '') => {
  amplitudeClient.setUserId(identity);
  if (organization.length > 0) amplitudeClient.setGroup('orgId', organization);

  siteblimpClient.identify(identity, { org: organization });

  initTrackingContext();
};

export const resetIdentity = () => {
  amplitudeClient.setUserId(null);
  amplitudeClient.regenerateDeviceId();

  siteblimpClient.reset();

  datadogClient.addRumGlobalContext('usr.email', undefined);
};
